const getTaskTitle = (taskNumber) => {
  if (taskNumber === 1) {
    return 'Sample Plate';
  }
  if (taskNumber === 2) {
    return 'Diluent Source';
  }
  return 'Normalization Setup';
};

export default getTaskTitle;
